import { useCallback, useEffect, useState } from "react";
import { IControlBase } from "../features/controls/types";
import useIsVisible from "./useIsVisible";
import { useApi } from "../contexts/ApiProvider";
import { TValues } from "../features/controls/details/MeasurementChartPainter";
import useControlAttribute from "./useControlAttribute";

export default function useControlMeasurements(
  control: IControlBase,
  measurements: string[],
): { value: any; valuesList: TValues[] | undefined } {
  const [valuesList, setValuesList] = useState<TValues[]>();
  const value = useControlAttribute(control, measurements[0]);
  const isVisible = useIsVisible();
  const api = useApi();
  const fetchData = useCallback(async () => {
    const response = await api.get<TValues[]>(
      `/controls/${control.id}/measurements`,
      {
        measurements: measurements.join(),
        numOfDays: "10",
      },
    );
    if (response.ok && response.body) {
      setValuesList(response.body as TValues[]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, control.id]);

  useEffect(() => {
    if (isVisible) {
      fetchData();
    }
  }, [value, isVisible, fetchData]);

  return { value, valuesList };
}
